import React from "react";

import DataSvg from "../../assets/images/icons/Data input.svg";

export const DataInputIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={DataSvg}
        alt={alt || "Data Input"}
    />
);
